import type { ReactNode } from 'react'

export type DetailCardVariant = 'plain' | 'tinted'

export type DetailCardPreviewState =
  | 'default'
  | 'tinted'
  | 'with-met'
  | 'with-highlight'
  | 'with-muted'
  | 'family'

export const DETAIL_CARD_PREVIEW_STATES: DetailCardPreviewState[] = [
  'default',
  'tinted',
  'with-met',
  'with-highlight',
  'with-muted',
  'family',
]

export const DETAIL_CARD_PREVIEW_STATE_LABELS: Record<
  DetailCardPreviewState,
  string
> = {
  default: 'Default (plain)',
  tinted: 'Tinted',
  'with-met': 'With met',
  'with-highlight': 'With highlight',
  'with-muted': 'With muted',
  family: 'Family sample',
}

export const DETAIL_CARD_DEMO_TITLE = 'Individual'

export type DetailCardRow = {
  label: ReactNode
  value: ReactNode
  /** Emphasized value (e.g. Remaining). */
  highlight?: boolean
  /** Softer value (e.g. “None”). */
  muted?: boolean
  /** Appends a green “• met” suffix (deductible met). */
  met?: boolean
}

export const DETAIL_CARD_DEMO_ROWS: DetailCardRow[] = [
  { label: 'Deductible', value: '$50.00', met: true },
  { label: 'Annual maximum', value: '$1,500.00 / $2,000.00' },
  { label: 'Remaining', value: '$500.00', highlight: true },
]

export const DETAIL_CARD_FAMILY_ROWS: DetailCardRow[] = [
  { label: 'Deductible', value: '$150.00' },
  { label: 'Annual maximum', value: 'None', muted: true },
]

export type DetailCardProps = {
  title?: ReactNode
  rows?: DetailCardRow[]
  /**
   * `plain` = white surface (Plan overall).
   * `tinted` = blue-100 surface (category-specific limits).
   */
  variant?: DetailCardVariant
  className?: string
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: DetailCardPreviewState
}

export type DetailCardGridProps = {
  children: ReactNode
  className?: string
}
